import {Dispatch, useState} from 'react';
import {CreditAccountController} from '../../../api/credit/credit-account.controller';
import {CreditRequestController} from '../../../api/credit/credit-request.controller';
import {useAsyncEffect} from '../../../hook/use-initial-load';
import {CreditAccountSummaryModel} from '../../../model/credit/credit-account-summary.model';
import {CreditRequestAttachmentModel} from '../../../model/credit/credit-request-attachment.model';
import {Searchable} from '../../../state/searchable-state';

export namespace CreditSupportPageHooks {
  import QueryCreditRequestsRes = CreditRequestController.QueryCreditRequestsRes;

  export const useCreditRequests = (searchable: Searchable): [QueryCreditRequestsRes | null, Dispatch<QueryCreditRequestsRes>] => {
    const [requests, setRequests] = useState<QueryCreditRequestsRes | null>(null)
    useAsyncEffect(async () => {
      setRequests(await fetchCreditRequests(searchable))
    }, [searchable.filters, searchable.groupedFilters, searchable.fullTextSearch, searchable.page, searchable.pageSize, searchable.ordering])
    return [requests, setRequests]
  }

  export const fetchCreditRequests = async (searchable: Searchable): Promise<QueryCreditRequestsRes> =>
    (await CreditRequestController.queryCreditRequests(searchable))

  export const useCreditAccount = (organizationId: string | null): [CreditAccountSummaryModel | null, Dispatch<CreditAccountSummaryModel | null>] => {
    const [account, setAccount] = useState<CreditAccountSummaryModel | null>(null)
    useAsyncEffect(async () => {
      if (organizationId) {
        setAccount(await CreditAccountController.getCreditAccountSummary(organizationId))
      } else {
        setAccount(null)
      }
    }, [organizationId])
    return [account, setAccount]
  }

  export const useCreditRequestAttachments = (requestId: string): [CreditRequestAttachmentModel[], Dispatch<CreditRequestAttachmentModel[]>] => {
    const [attachments, setAttachments] = useState<CreditRequestAttachmentModel[]>([])
    useAsyncEffect(async () => {
      setAttachments(await CreditRequestController.queryCreditRequestAttachments(requestId))
    }, [requestId])
    return [attachments, setAttachments]
  }
}
